import confetti from 'canvas-confetti';

/**
 * Dispara una ráfaga de confeti de celebración en la pantalla.
 * @param {object} [options] - Opciones opcionales de posición o configuración.
 * @param {number} [options.x] - Posición X normalizada (0.0 a 1.0).
 * @param {number} [options.y] - Posición Y normalizada (0.0 a 1.0).
 */
export const triggerTaskCompletedConfetti = (options = {}) => {
    try {
        const originX = options.x !== undefined ? options.x : 0.5;
        const originY = options.y !== undefined ? options.y : 0.6;

        // Ráfaga primaria centrada en el origen
        confetti({
            particleCount: 45,
            spread: 60,
            origin: { x: originX, y: originY },
            colors: ['#22c55e', '#3b82f6', '#f59e0b', '#ec4899', '#8b5cf6'],
            ticks: 200,
            gravity: 1.1,
            scalar: 0.9,
            disableForReducedMotion: true
        });

        // Sub-ráfaga secundaria sutil para sensación de dispersión física
        setTimeout(() => {
            confetti({
                particleCount: 25,
                angle: 60,
                spread: 55,
                origin: { x: Math.max(0.1, originX - 0.1), y: Math.min(0.9, originY + 0.05) },
                colors: ['#10b981', '#6366f1', '#f43f5e'],
                ticks: 150,
                gravity: 1.2,
                scalar: 0.7,
                disableForReducedMotion: true
            });
        }, 80);

        setTimeout(() => {
            confetti({
                particleCount: 25,
                angle: 120,
                spread: 55,
                origin: { x: Math.min(0.9, originX + 0.1), y: Math.min(0.9, originY + 0.05) },
                colors: ['#3b82f6', '#eab308', '#a855f7'],
                ticks: 150,
                gravity: 1.2,
                scalar: 0.7,
                disableForReducedMotion: true
            });
        }, 120);
    } catch (error) {
        console.warn('Confetti effect failed:', error);
    }
};
